import { isUiSettingRemoved } from "../../../../domain/uiSetting/model/uiSettingRemoved";
const storageUiSettingsRemove = ({ storage }) => async ({ aggregateId, domainEvents }) => {
    const uiSettingRemoved = domainEvents.find(isUiSettingRemoved);
    if (!uiSettingRemoved) {
        return;
    }
    await storage.remove(aggregateId);
};
export { storageUiSettingsRemove };
